import { InputText, Text } from "@pentabd/ui";
import { AnnualProcurementType } from "@type/procurements/annualProcurementPlan";
import { useTranslation } from "react-i18next";

type ProcurementDetailsFormType = {
  procurement: AnnualProcurementType;
  id: number | string;
  remainingAppTotalBudget: number;
};

export const ProcurementDetailsForm = ({
  procurement,
  id,
  remainingAppTotalBudget,
}: ProcurementDetailsFormType) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-column gap-8">
      <div className="row">
        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                {t("APP_DETAILS.FORM.NAME.LABEL")}
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="name"
                className="fs-md"
                placeholder={t("APP_DETAILS.FORM.NAME.PLACEHOLDER")}
                disabled
                value={procurement?.title || ""}
                controlling
              />
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                {t("APP_DETAILS.FORM.CREATED_DATE.LABEL")}
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="date"
                className="fs-md"
                placeholder={t("APP_DETAILS.FORM.CREATED_DATE.PLACEHOLDER")}
                disabled
                value={procurement?.createdDate || ""}
                controlling
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                {t("APP_DETAILS.FORM.REF_NO.LABEL")}
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="ref"
                className="fs-md"
                placeholder={t("APP_DETAILS.FORM.REF_NO.PLACEHOLDER")}
                disabled
                value={procurement?.appRefNo || ""}
                controlling
              />
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                {t("APP_DETAILS.FORM.YEAR.LABEL")}
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="year"
                className="fs-md"
                placeholder={t("APP_DETAILS.FORM.YEAR.PLACEHOLDER")}
                disabled
                value={procurement?.financialYear || ""}
                controlling
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                {t("APP_DETAILS.FORM.APP_TOTAL_BUDGET.LABEL")}
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="AppTotalBudget"
                className="fs-md"
                placeholder={t("APP_DETAILS.FORM.APP_TOTAL_BUDGET.PLACEHOLDER")}
                disabled
                value={procurement?.budget?.toString() || ""}
                controlling
              />
            </div>
          </div>
        </div>

        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                {t("remaing total budget")}
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="AppTotalBudget"
                className="fs-md"
                type="number"
                placeholder={t("APP_DETAILS.FORM.APP_TOTAL_BUDGET.PLACEHOLDER")}
                disabled
                value={remainingAppTotalBudget?.toString() || ""}
                controlling
              />
            </div>
          </div>
        </div>
        {/* <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                Package Budget
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="packageBudget"
                className="fs-md"
                placeholder="Enter Name"
                disabled
              />
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};
